import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorBehaviourModel } from '../model/focus-selector-behaviour.model';

export interface FocusSelectorFilterFocuses {
    behaviourId: FocusSelectorBehaviourModel['id'];
}

export const focusSelectorFilterFocuses = createAction<
    ActionType,
    FocusSelectorFilterFocuses
>(ActionType.COACHING_FOCUS_SELECTOR__FILTER_FOCUSES);
